"use client";

import useTranslate from "@app/_hooks/useTranslate";
import type { Sort, SortType } from "@apptus/esales-api";
import removeUnwantedQueryParams from "@features/filter/services/removeUnwantedQueryParams";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@ui/select";
import { useRouter, useSearchParams } from "next/navigation";
import { ComponentProps } from "react";

export default function Sort({
  sort,
  className,
  placeholder,
  ...props
}: {
  sort: Sort<SortType>;
  placeholder?: string;
} & ComponentProps<typeof Select> & { className?: string }) {
  const t = useTranslate();
  const router = useRouter();
  const searchParams = useSearchParams();

  function onChange(value: string) {
    if (value === sort.selected) return;
    const params = new URLSearchParams(searchParams);
    params.set("sort", value);

    router.replace(`?${removeUnwantedQueryParams(params).toString()}`);
  }

  return (
    <div className={className}>
      <Select value={sort.selected} onValueChange={onChange} {...props}>
        <SelectTrigger className="border-0">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="RELEVANCE">{t("sort_favorites")}</SelectItem>
          <SelectItem value="NEWEST_FIRST">{t("sort_newest")}</SelectItem>
          <SelectItem value="NAME">{t("sort_name_asc")}</SelectItem>
          <SelectItem value="PRICE_ASCENDING">{t("sort_price_asc")}</SelectItem>
          <SelectItem value="PRICE_DESCENDING">
            {t("sort_price_desc")}
          </SelectItem>
          {sort.selected &&
            ![
              "RELEVANCE",
              "NEWEST_FIRST",
              "NAME",
              "PRICE_ASCENDING",
              "PRICE_DESCENDING",
            ].includes(sort.selected) && (
              <SelectItem value={sort.selected}>{sort.selected}</SelectItem>
            )}
        </SelectContent>
      </Select>
    </div>
  );
}
